import React, { useState } from "react";
import { ModalChiTiet } from "./ModalChiTiet";

const BtnChiTiet = ({ item }) => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <>
      <div className="center-wrapper">
        <span className="profile_name  word-break ">
        <a
          className="blue btn-link"
          onClick={e => { e.preventDefault(); handleShow(); }}
        >
          {item?.ContractName}
        </a>
        </span>
      </div>
      {show && (
        <ModalChiTiet
          show={show}
          onHide={handleClose}
          item={item}
        />
      )}
    </>
  );
};

export default BtnChiTiet;
